import { Component, Input, OnInit } from '@angular/core';
import { get } from 'lodash';
import { IWizardContentComponent } from '../../../wizard.content';
import {
  ApplicationType,
  APP_TYPE_KEY
} from './../app.review.page/review.component';
import { ApplicationWizardService } from '../../../services/application/application.wizard.service';

@Component({
  selector: 'app-create-results-html',
  templateUrl: './create.results.html',
  providers: [],
  styleUrls: [
    '../../../wizard.button.style.scss',
    '../new.application.style.scss',
    './create.results.style.scss'
  ]
})
export class CreateResultsHtmlComponent
  implements IWizardContentComponent, OnInit {
  @Input() step: any;
  @Input() subStep: any;
  @Input() wizardCtrl: any;
  @Input() id: string;
  @Input() previousOutput: any;
  appType: ApplicationType;
  failureMsg: string;
  successFlag: string;
  successMsg: string;

  constructor(private wizardService: ApplicationWizardService) {}

  ngOnInit() {
    this.appType = get(
      this.previousOutput,
      APP_TYPE_KEY,
      ApplicationType.CLOUD_BASED
    );
    this.generateTextByMode(this.wizardService.editMode);
  }

  generateTextByMode(editMode) {
    if (!editMode) {
      this.failureMsg = 'We had some issues creating your application';
      this.successMsg = 'Your application has been successfully added';
      this.successFlag = 'Created';
    } else {
      this.failureMsg = 'We had some issues updating your application';
      this.successMsg = 'Your application has been successfully updated';
      this.successFlag = 'Updated';
    }
  }

  isLoading() {
    return this.wizardCtrl.getWizardService().isLoading;
  }

  requestFailed() {
    return this.wizardCtrl.getWizardService().requestFailed;
  }

  isCloudBased() {
    return this.appType === ApplicationType.CLOUD_BASED;
  }

  isOnPremise() {
    return this.appType === ApplicationType.ON_PREMISE;
  }
}
